import React from "react";
import "./Chat.css";

function ChatCardTwo({id,tasId, customerId, message}) {
  return (
    <div style={{width: '200px',borderRadius: '20px',backgroundColor: 'white'}} className="wrappers">
      <div className="content">
      
        <div className="main">
          <div className="main_content">
            <div className="messages">
             
              <div
                className="human-message"
                id="message2"
                
              >aaa</div>
            </div>
          </div>
        </div>
      
      </div>
    </div>
  );
}

export default ChatCardTwo;
